import { render, staticRenderFns } from "./ChiefDeptRatingView.vue?vue&type=template&id=c32610ba"
import script from "./ChiefDeptRatingView.vue?vue&type=script&lang=js"
export * from "./ChiefDeptRatingView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports